import { useMemo } from "react";

import styled from "@mui/material/styles/styled";
import Typography from "@mui/material/Typography";

import { formatVideoTimeFromSeconds } from "@app/analytics/utils";

import Stack, { Row } from "@rui/Stack";

export const Wrapper = styled(Stack)({
  backgroundColor: "rgba(0,0,0,0.8)",
  borderRadius: "8px",
  padding: "4px 8px 6px",
});

const StyledText = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography.fontFamilySecondary,
  color: "#fff",
  fontSize: "0.875rem",
  fontWeight: 500,
  lineHeight: "17px",
}));

export const SegmentLabel = styled(StyledText)({
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
});

export const CurrentTime = ({
  currentTime,
  duration,
}: {
  currentTime?: number;
  duration?: number;
}) => {
  const currentTimeString = useMemo(
    () => formatVideoTimeFromSeconds(currentTime),
    [currentTime]
  );
  const endTimeString = useMemo(
    () => formatVideoTimeFromSeconds(duration),
    [duration]
  );

  return (
    <Row variant="left" spacing="4px" className="current-time">
      <StyledText>{currentTimeString}</StyledText>
      <StyledText>/</StyledText>
      <StyledText>{endTimeString}</StyledText>
    </Row>
  );
};
